var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"lista-licenca"}},[_c('div',{staticClass:"nome"},[_vm._v(_vm._s(_vm.licenca ? _vm.licenca.protocolo : null))]),_c('div',{staticClass:"status"},[_c('status-badge',{attrs:{"status":_vm.licenca ? _vm.licenca.status : null}})],1),_c('div',{staticClass:"boleto"},[_vm._v("Baixar TODO")])])
}
var staticRenderFns = []

export { render, staticRenderFns }